export default __webpack_public_path__ + "static/Resume-0c1acc2975412f510d471db70ce67e36.pdf";